import { render, staticRenderFns } from "./SubFolderName.vue?vue&type=template&id=11f6dda5&scoped=true&"
import script from "./SubFolderName.vue?vue&type=script&lang=js&"
export * from "./SubFolderName.vue?vue&type=script&lang=js&"
import style0 from "./SubFolderName.vue?vue&type=style&index=0&id=11f6dda5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f6dda5",
  null
  
)

export default component.exports